export default __webpack_public_path__ + "static/media/LogoVaisandLight.027051ed.svg";